import React from "react";

const FirmaDocumentoGenericoMisDocumentosContext = React.createContext();

export default FirmaDocumentoGenericoMisDocumentosContext;